
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

export default {
components: {
Cell,
Group,
CellBox,
Confirm,
Alert,
XButton,
Tab,
TabItem,
Swiper,
SwiperItem
},
name: 'invitation',
data () {
return {
select:'',
account: '',
orders_closed: [],
orders_unclosed: [],
list: ['未完成', '已完成'],
index: 0,
loadmoreone:'加载更多',
loadmoretwo:'加载更多',
show:true,
hide:true,
isDisabled:false
}
},
methods:{

showMoreorders () {
var offset
var closed
this.isDisabled = true
if (this.index === 1) {
offset = this.orders_closed.length
closed = true
} else {
offset = this.orders_unclosed.length
closed = false
}
var app = this
var openid = localStorage.getItem('openid')

AjaxPlugin.$http.get('/api/v1/fastrepairs?openid='+openid+'&offset='+offset+'&count=10&closed='+closed)
.then(function (response) {
app.isDisabled = false
if (app.index === 1){
app.loadmoretwo = '加载中'
if(response.data.content.length>0){
app.loadmoretwo = '加载更多'
}else{
app.hide = false
}
}
else{
app.loadmoreone = '加载中'
if(response.data.content.length>0){
app.loadmoreone = '加载更多'
}else{
app.show = false
}
}
var orders = []
orders = response.data.content
for (var i = 0; i < orders.length; i++) {
if (app.index === 0) {
switch (orders[i]['confirm']) {
case 'YES':
orders[i]['confirm'] = '已确认'
break
case 'NO':
orders[i]['confirm'] = '未确认'
break
case 'INVALID':
orders[i]['confirm'] = '无效'
break
case 'FAIL':
orders[i]['confirm'] = '处理失败'
break
case 'SUCCESS':
orders[i]['confirm'] = '处理成功'
break
default:
break
}
}
if (app.index === 1) {
app.orders_closed.push(orders[i])
} else {
app.orders_unclosed.push(orders[i])
}
}
})
.catch(function (error) {
app.isDisabled = false
if (error.response) {
console.log(error.response.data)
if (error.response.data) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
},
created () {
var app = this
var openid = localStorage.getItem('openid')


AjaxPlugin.$http.get('/api/v1/fastrepairs?openid='+openid+'&offset=0&count=10&closed=true')
.then(function (response) {
app.orders_closed = response.data.content
for (var i = 0; i < app.orders_closed.length; i++) {
switch (app.orders_closed[i]['confirm']) {
case 'YES':
app.orders_closed[i]['confirm'] = '已确认'
break
case 'NO':
app.orders_closed[i]['confirm'] = '未确认'
break
case 'FAIL':
app.orders_closed[i]['confirm'] = '处理失败'
break
case 'INVALID':
app.orders_closed[i]['confirm'] = '无效'
break
case 'SUCCESS':
app.orders_closed[i]['confirm'] = '处理成功'
break
default:
break
}
}
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
}
else if (error.request) {
console.log(error.request)
}
else {
console.log('Error', error.message)
}
})



AjaxPlugin.$http.get('/api/v1/fastrepairs?openid='+ openid +'&offset=0&count=10&closed=false')
.then(function (response) {
app.orders_unclosed = response.data.content






console.log(app.orders_unclosed)
for (var i = 0; i < app.orders_unclosed.length; i++) {
switch (app.orders_unclosed[i]['confirm']) {
case 'YES':
app.orders_unclosed[i]['confirm'] = '已确认'
break
case 'NO':
app.orders_unclosed[i]['confirm'] = '未确认'
break
case 'FAIL':
app.orders_unclosed[i]['confirm'] = '处理失败'
break
case 'INVALID':
app.orders_unclosed[i]['confirm'] = '无效'
break
case 'SUCCESS':
app.orders_unclosed[i]['confirm'] = '处理成功'
break
default:
break
}
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
}
else if (error.request) {
console.log(error.request)
}
else {
console.log('Error', error.message)
}
})
},
beforeRouteLeave(to, from, next){
if(to.name == 'quicklycomplete'){
next()
}
else {
localStorage.removeItem('order')
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/rapidrepairslist.vue